"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "avatar-file-input"
  }, [_c("div", {
    staticClass: "avatar-preview"
  }, [_vm.avatarSrc ? _c("img", {
    attrs: {
      src: _vm.avatarSrc,
      alt: "User Avatar"
    }
  }) : _c("div", {
    staticClass: "avatar-placeholder"
  }, [_c("img", {
    attrs: {
      src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAA20lEQVR4nO2UQQrCQAxF/zG0XshqS0/gzl3BpXUlggheqrZn0RPYunFjZeALIslgzbjSQDb56X/TJh3gF2IBoFNyaTWfAbh5AE6bv2s2AXBSjHKhP1d6nUcsATTzjedQa+WZo9T8EK3RaT4+QAagBnBhVgDSUIC9Z8g7KyBj7cqVjJgFa05LLICaNWf4GgW1gwXQsjYU+gfUmhCASOgfUTtbAJXnE62olRZA+jTkQhny1AIAV1Fb0y0C/WgJt6VllsLJTYA+ofpol133QYqXXUwhhPm41zv/A9+MO74ysZQOexG2AAAAAElFTkSuQmCC"
    }
  })])]), _vm._v(" "), _c("div", {
    staticClass: "file-input-wrapper"
  }, [_c("input", {
    ref: "uploadInput",
    attrs: {
      type: "file",
      accept: "image/png, image/jpeg",
      hidden: ""
    },
    on: {
      change: _vm.onFileChange
    }
  }), _vm._v(" "), _c("button", {
    staticClass: "upload-photo-button",
    on: {
      click: _vm.triggerUploadInput
    }
  }, [_vm._v("\n      Escolher Foto\n    ")]), _vm._v(" "), _vm.avatar ? _c("button", {
    staticClass: "upload-photo-clear",
    on: {
      click: _vm.clearAvatar
    }
  }, [_vm._v("\n      Remover foto selecionada\n    ")]) : _vm._e(), _vm._v(" "), _c("p", {
    staticClass: "helper-text",
    class: {
      error: _vm.errorMessage
    }
  }, [_vm._v("\n      " + _vm._s(_vm.errorMessage || _vm.helperText) + "\n    ")])])]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;